export const SEARCHES_KEY = 'search:autocomplete:history';

export function getNavigatorLastRecentSearchTerms(num?: number): string[] {
    try {
        const searchTerms = localStorage.getItem(SEARCHES_KEY);
        if (!searchTerms) {
            return [];
        }

        const terms = searchTerms
            .split(',')
            .map((q) => q.trim().toLowerCase())
            .filter((q: string) => !!q);

        if (num) {
            return terms.slice(0, num);
        }
        return terms;
    } catch (e) {
        return [];
    }
}

export const addNavigatorSearchTerm = (search: string) => {
    const MAX_SEARCHES_STORED = 40;
    const searches = getNavigatorLastRecentSearchTerms();
    searches.unshift(search.trim());
    const uniqueSearches = Array.from(new Set(searches));
    const nonEmptyUniqueSearches = uniqueSearches.filter((s) => s);
    const lastFortySearches = nonEmptyUniqueSearches.slice(
        0,
        MAX_SEARCHES_STORED,
    );
    localStorage.setItem(SEARCHES_KEY, lastFortySearches.join(','));
};
